import { useUser } from 'vl-core/hooks/useUser';

export function useIsPatient() {
  const { user_type_code: userType } = useUser();

  return userType === 'PATIENT';
}

export default useIsPatient;
